import { Button } from '@/components/ui/button';
import { cn } from '@/components/ui/utils';
import { useHumanReadableFormatter } from '@/hooks/use-human-readable-formatter';
import { Edit2, Plus, Wand2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export type EditMode = 'this-transaction' | 'all-similar';

interface FormattedHumanReadableRuleProps {
  rawText: string;
  onEditRule?: () => void;
  onCreateNewRule?: () => void;
  className?: string;
}

export function FormattedHumanReadableRule({
  rawText,
  onEditRule,
  onCreateNewRule,
  className,
}: FormattedHumanReadableRuleProps) {
  const { t } = useTranslation();
  const appliedRuleText = useHumanReadableFormatter(rawText);

  return (
    <div
      className={cn(
        'mt-6 rounded-lg border bg-muted/50 p-3 space-y-2',
        className
      )}
    >
      <div className='flex items-center gap-2 text-sm font-medium'>
        <Wand2 className='h-4 w-4' />
        {t('rules.automaticRuleApplied')}
      </div>
      <p className='text-sm text-muted-foreground leading-relaxed'>
        {appliedRuleText}
      </p>
      <div className='flex gap-2'>
        {!!onEditRule && (
          <Button variant='outline' size='sm' onClick={onEditRule}>
            <Edit2 className='h-4 w-4' />
            {t('rules.editRule')}
          </Button>
        )}
        {!!onCreateNewRule && (
          <Button variant='outline' size='sm' onClick={onCreateNewRule}>
            <Plus className='h-4 w-4' />
            {t('rules.createNewRule')}
          </Button>
        )}
      </div>
    </div>
  );
}
